import { render, staticRenderFns } from "./DefaultPayrunSetting.vue?vue&type=template&id=69c0e3ed"
import script from "./DefaultPayrunSetting.vue?vue&type=script&lang=js"
export * from "./DefaultPayrunSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports